import React, { useState, useEffect, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';


const sets = [
  { id: 'Set_A', label: '251-Jamalpur-Test' },
  { id: 'Set_B', label: '237-Varanasi-Test' },
  { id: 'Set_D', label: '245-Mysore-Test' },
  { id: 'Set_F', label: '238-Nanded-Test' },
  { id: 'Set_H', label: '203-Mumbai-Test' },
  { id: 'Set_O', label: '208-Shift-1-Test' },
  { id: 'Set_U', label: '210-Test' },
  { id: 'Set_W', label: '220-Katihar-Test' },
  { id: 'Set_X', label: '213-Ajmer-Test' },
  { id: 'Set_Y', label: 'Hubli-CBT-Test' },
  { id: 'Set_27', label: 'JODHPUR (NWR)-Test' },
  { id: 'Set_C', label: 'Hindi-Rajbhasha-Test' },
  { id: 'Set_E', label: 'Paint and Trimming' },
  { id: 'Set_J', label: 'AIR BRAKE SYSTEM' },
  { id: 'Set_K', label: 'MILWRIGHT - MACHINES' },
  { id: 'Set_G', label: 'Maths-Test-SET-1' },
  { id: 'Set_I', label: 'Maths-Test-SET-2' },
  { id: 'Set_P', label: 'Maths-Test-SET-3' },
  { id: 'Set_28', label: 'Maths-Test-SET-4' },
  { id: 'Set_30', label: 'Maths-Test-SET-5 (Geometry)' },
  { id: 'Set_L', label: 'Test_NOV-28-Friday' },
  { id: 'Set_Q', label: 'Test_NOV-30-Sunday' },
  { id: 'Set_Z', label: 'Test_DEC-05-Friday' },
  { id: 'Set_33', label: 'Test_DEC-12-Friday' },
  { id: 'Set_M', label: 'GK - Physics' },
  { id: 'Set_N', label: 'GK - Chemistry' },
  { id: 'Set_R', label: 'GK - Art & Culture' },
  { id: 'Set_31', label: 'GK - Combined' },
  { id: 'Set_32', label: 'GK - Railway' },
  { id: 'Set_S', label: 'Combined Test' },
  { id: 'Set_T', label: 'Integral Coach Factory (ICF)' },
  { id: 'Set_V', label: 'LHB' },
  { id: 'Set_39', label: 'Air Brake' },
  { id: 'Set_34', label: 'Vande Bharat' },
  { id: 'Set_35', label: 'Disaster Management' },
  { id: 'Set_36', label: 'Factory act' },
  { id: 'Set_37', label: 'Permanent Negotiating Machinery (PNM)' },
  { id: 'Set_29', label: 'English Test' },
  { id: 'Set_38', label: 'English Test - PYQ' },
  
  { id: 'Set_40', label: 'Practice Set A' },
  { id: 'Set_41', label: 'Practice Set B' },
  { id: 'Set_42', label: 'Practice Set C' },
  { id: 'Set_43', label: 'Practice Set Random' },
  { id: 'Set_44', label: 'Practice Set - Question Bank' },
  { id: 'Set_45', label: 'Practice Set - GK' },
  { id: 'Set_46', label: 'RDSO' },
  { id: 'Set_47', label: 'Rajbhasha 2026 Set-1' },
  { id: 'Set_48', label: 'Rajbhasha 2026 Set-2' },
  { id: 'Set_49', label: 'Rajbhasha 2026 Set-3' },
  { id: 'Set_50', label: 'GK 2026 Set-1' },
  { id: 'Set_51', label: 'GK 2026 Set-2' },

  { id: 'Set_52', label: 'General Science 2026 Set-1' },
  { id: 'Set_53', label: 'General Science 2026 Set-2' },
  { id: 'Set_54', label: 'General Science 2026 Set-3' },
  { id: 'Set_55', label: 'General Science 2026 Set-4' },
  { id: 'Set_56', label: 'General Science 2026 Set-5' },

  { id: 'Set_57', label: 'General Knowledge 2026 Set-1' },
  { id: 'Set_58', label: 'General Knowledge 2026 Set-2' },
  { id: 'Set_59', label: 'General Knowledge 2026 Set-3' },
  { id: 'Set_60', label: 'General Knowledge 2026 Set-4' },
  { id: 'Set_61', label: 'General Knowledge 2026 Set-5' }
]; // Add more dynamically here or from props

const ExamSelector = ({ onSelect, selectedSet, showPapersList, onProceed }) => {
  const [localSelectedSet, setLocalSelectedSet] = useState(selectedSet || '');
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    setLocalSelectedSet(selectedSet || '');
  }, [selectedSet]);

  const handleProceed = () => {
    if (onProceed) {
      onProceed();
    } else if (localSelectedSet) {
      onSelect(localSelectedSet);
    } else {
      alert('Please select an exam set before proceeding.');
    }
  };

  const handleSelectOption = (id) => {
    setLocalSelectedSet(id);
    onSelect(id);
    setSearchTerm('');
  };

  // Filter sets based on search term
  const filteredSets = sets.filter((set) =>
    set.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get selected set label
  const selectedLabel = sets.find((set) => set.id === localSelectedSet)?.label || '-- Select Exam Set --';

  // If showing papers list (right panel)
  if (showPapersList) {
    return (
      <div className="papers-list-container" ref={dropdownRef}>
        {/* Search Box */}
        <div className="papers-search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            className="papers-search-input"
            placeholder="Search exam papers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Scrollable Papers List */}
        <div className="papers-scrollable-list">
          {filteredSets.length > 0 ? (
            filteredSets.map(({ id, label }) => (
              <div
                key={id}
                className={`paper-item ${localSelectedSet === id ? 'selected' : ''}`}
                onClick={() => handleSelectOption(id)}
              >
                {label}
              </div>
            ))
          ) : (
            <div className="papers-no-results">No exam papers found</div>
          )}
        </div>
      </div>
    );
  }

  // Main selector (left side)
  return (
    <div className="exam-selector-main" ref={dropdownRef}>
      <div className="selected-paper-display">
        <h3>Selected Paper</h3>
        <div className="selected-paper-box">
          {localSelectedSet ? selectedLabel : 'No paper selected'}
        </div>
      </div>

      <button className="exam-select-proceed-btn" onClick={handleProceed}>
        Proceed to Exam
      </button>
    </div>
  );
};

export default ExamSelector;
